module.exports = __webpack_public_path__ + "static/media/DTSA-25-ICONS-21.30d60239.png";